import * as l from "react";
const a = (e) => /* @__PURE__ */ l.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ l.createElement(
    "path",
    {
      d: "M20.12 11.95l-6.58 6.59a5.003 5.003 0 01-7.08-7.07l6.59-6.6a3.002 3.002 0 114.24 4.25l-6.58 6.59a1.004 1.004 0 01-1.42-1.42l6.59-6.58a1.004 1.004 0 10-1.42-1.42l-6.58 6.59a3 3 0 004.24 4.24l6.59-6.58a5.006 5.006 0 10-7.08-7.08l-6.58 6.6a7 7 0 009.9 9.9l6.59-6.6a1 1 0 00-1.42-1.4v-.01z",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
